<template>
  <v-container fluid class="mt-4">
    <v-row>
      <v-col cols="12" lg="10" xl="9">
        <v-card>
          <v-container fluid class="my-4 py-4">
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  {{ $t("searchMultiRules.info") }}
                </v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="$vuetify.breakpoint.mdAndUp"
                ></v-divider>
                <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
                <v-row justify="end">
                  <v-btn
                    class="mx-4 my-1"
                    depressed
                    color="secondary"
                    @click="importFav"
                    :disabled="!isFavImport"
                  >
                    {{ $t("searchMultiRules.import") }}
                  </v-btn>

                  <v-btn
                    class="mx-4 my-1"
                    depressed
                    color="primary"
                    @click="searchRules"
                    :disabled="!multiRulesSelection.length"
                  >
                    <v-icon class="mr-2"> mdi-magnify </v-icon>
                    {{ $t("generic.Search") }}
                  </v-btn>
                </v-row>
              </v-toolbar>
            </v-row>
            <!-- TreeView -->
            <v-row align="start">
              <rules-tree :type="'multiRules'"></rules-tree>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RulesTree from "../components/RulesTree.vue";
import { mapGetters, mapMutations } from "vuex";
import { monitore } from "../components/helpers/helpers";

export default {
  data() {
    return {
      isFavImport: true,
    };
  },
  components: {
    RulesTree,
  },

  computed: {
    ...mapGetters(["rules_fav", "multiRulesSelection"]),
  },

  methods: {
    ...mapMutations(["setLastPage", "setMultiRulesSelection"]),
    importFav() {
      let tmpSelection = [...this.multiRulesSelection];
      // console.log(this.multiRulesSelection);
      this.rules_fav.forEach((fav) => {
        if (tmpSelection.indexOf(fav) < 0) {
          tmpSelection.push(fav);
        } else {
          // console.log("déjà en fav");
        }
      });
      if (tmpSelection.length !== this.multiRulesSelection.length) {
        this.setMultiRulesSelection(tmpSelection);
        this.$router.go(); //refresh the page
        this.isFavImport = false;
      }
    },
    isFavToImport() {
      this.isFavImport = false;
      this.rules_fav.forEach((fav) => {
        if (this.multiRulesSelection.indexOf(fav) < 0) {
          this.isFavImport = true;
        }
      });
    },
    searchRules() {
      this.fetchResult(this.multiRulesSelection);
    },
    async fetchResult(rulesIDs) {
      try {
        let url = "/rules/nbbytheme";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            liste: rulesIDs,
          },
        });
        // console.log(response);
        if (response.status === 200) {
          monitore("Search multi rules", rulesIDs);
          if (response.data.length) {
            let results = response.data;
            // console.log("RESULT : ", results);
            this.$router.push({
              name: "SearchMultiRulesResult",
              params: { results: results },
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeMount() {
    this.isFavToImport();
  },
  watch: {
    multiRulesSelection() {
      this.isFavToImport();
    },
  },
};
</script>
